import { render, staticRenderFns } from "./BetTransaction.vue?vue&type=template&id=2c0468a0"
import script from "./BetTransaction.vue?vue&type=script&lang=ts"
export * from "./BetTransaction.vue?vue&type=script&lang=ts"
import style0 from "./BetTransaction.vue?vue&type=style&index=0&id=2c0468a0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports